import React from 'react'
import { ImageDivStyle, TextWrapper } from './styles'


const ImageDiv = () => {

    return <ImageDivStyle >
            <TextWrapper>
                <small>
                    Do you know you can become a contributor and earn side cash? It's ease! Create an account to unlock a milestone
                </small>
            </TextWrapper>
    </ImageDivStyle>
}

export default ImageDiv

